<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <div v-if="is_header_top" class="header-top  container-fuild hidden-xs">
      <div class="container_top">
        <div  style="float: left; margin-left: 18.5%" >
          <span class="glyphicon glyphicon-earphone"></span>{{ companyInfo.tel }}
          <span style="padding: 0 15px 0px 15px">|</span>
          <span class="glyphicon glyphicon-envelope"></span>{{ companyInfo.emile }}
          <span style="padding: 0 15px 0px 15px">|</span>
          <span class="glyphicon glyphicon-earphone"></span> {{ $t('frame.hours') }}
        </div>

        <div  style="float: right; margin-right: 18.5%">
          <span @click="changeLangEvent('zh-CN')" style="cursor: pointer"
                v-bind:style="{ color: langZhClass.color, paddingLeft: langZhClass.paddingLeft + 'px' }"
                v-bind:class="langZhClass">中文</span>
          <span>|</span>
          <span @click="changeLangEvent('en-US')" style="cursor: pointer"
                v-bind:style="{ color: langEnClass.color, paddingLeft: langEnClass.paddingLeft + 'px' }">ENGLISH</span>
        </div>
      </div>
    </div>
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs" >
      <!-- 导航logo -->
      <div class="header-nav-logo" @click="reMain">
        <img src="@/assets/img/h-logo.png">
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper"  style=" display:flex; z-index: 100;	justify-content:center;">
        <li style="padding: 0 18px 18px 0"  v-for="(item,index) in navList" :key="index" :class="index==navIndex?'active':''" @click="navClick(index,item.name)">
          <router-link :to="item.path" style="font-size: 17px; ">
             {{ $t(item.name) }}
            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length>0">
            <dt v-for="(i,n) in item.children" :key="n">
              <router-link :to="i.path">{{ i.name }}</router-link>
            </dt>
          </dl>
        </li>

<!--        <li style="font-size: 15px">-->
<!--          <span @click="changeLangEvent('zh-CN')" style="cursor: pointer"-->
<!--                v-bind:style="{ color: langZhClass.color, paddingLeft: langZhClass.paddingLeft + 'px' }"-->
<!--                v-bind:class="langZhClass">中文</span>-->
<!--          <span style="padding-left: 10px"> | </span>-->
<!--          <span @click="changeLangEvent('en-US')" style="cursor: pointer"-->
<!--                v-bind:style="{ color: langEnClass.color, paddingLeft: langEnClass.paddingLeft + 'px' }">English</span>-->
<!--        </li>-->
      </ul>

    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="@/assets/img/h-logo.png">
      </div>
      <!-- 导航栏 -->

      <!-- 导航内容 -->
      <div class="header-nav-m-menu text-center" >
        {{ $t(menuName) }}
        <div  class="header-nav-m-menu-wrapper"  data-toggle="collapse" data-target="#menu" @click="menuClick" >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse" >

          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="index==navIndex?'active':''"
            @click="navClick(index,item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >

            <router-link  :to="item.path">
              <div style="width: 100%;">
                {{ $t(item.name) }}
              </div>

              <i class="underline"></i>
            </router-link>
          </li>


          <li style="text-align: center; ">
          <span @click="changeLangEvent('zh-CN')" style="cursor: pointer"
                v-bind:style="{ color: langZhClass.color, paddingLeft: langZhClass.paddingLeft + 'px' }"
                v-bind:class="langZhClass">中文</span>
            <span style="padding-left: 10px; padding-right: 10px"> | </span>
            <span @click="changeLangEvent('en-US')" style="cursor: pointer;"
                  v-bind:style="{ color: langEnClass.color, paddingLeft: langEnClass.paddingLeft + 'px' }">English</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      companyInfo: {}, //公司信息
      navList: [
        {
          name: "header.home",
          path: "/",
          children: []
        },
        {
          name: "header.us",
          path: "/companyintroduction",
          children: []
        },
        {
          name: "header.product",
          path: "/software",
          children: [
            // {
            //   name: "智能小镇管理系统",
            //   path: "/software/smartTown"
            // },
            // {
            //   name: "大数据管理系统",
            //   path: "/software/bigData"
            // }
          ]
        },
        {
          name: "header.Quality",
          path: "/service",
          children: []
        },
        {
          name: "header.News",
          path: "/newsinformation",
          children: []
        },

        {
          name: "header.career_opportunities",
          path: "/jobchance",
          children: []
        },
        {
          name: "header.contact_us",
          path: "/contactus",
          children: []
        }
      ],

      is_header_top: true, //设置header-top是否隐藏

      langZhClass: {
        color: '#fff',
        paddingLeft: 0
      },
      langEnClass: {
        color: '#b6b6b6',
        paddingLeft: 0
      }
    };
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  watch:{
    $route(to,from){
      console.log('页面跳转------',to)
      if(to.path === '/software/smartTown'){
        this.navIndex = 2;
        sessionStorage.setItem('navIndex', 2)
        this.menuName = 'header.product';
        return
      }

      if(to.path === '/home'){
        this.navIndex = 0;
        sessionStorage.setItem('navIndex', 0)
        this.menuName = 'header.home';
        return
      }
      for(let i in this.navList){
        if(this.navList[i].path === to.path){
          this.navIndex = i;
          sessionStorage.setItem('navIndex', i)
          this.menuName = this.navIndex[i].name;
        }
      }

    }
  },

  created() {
    //获取ip和地址
   // console.log(localStorage.getItem('Ip'))
   //  console.log(localStorage.getItem('cityname'))
    this.$i18n.locale = 'zh-CN'
    // console.log('11111==============================================')
    // console.log(this.$i18n.locale)
    this.$axios({
      // 默认请求方式为get
      method: 'get',
      url: this.api.baseURL + '/companyInfo/companyData?ip='+localStorage.getItem('Ip')+'&address='+localStorage.getItem('cityname'),
      responseType: 'json'
    }).then(response => {
      // 请求成功
      let res = response.data;
      //公司信息设置到内存
      localStorage.setItem('companyData',  JSON.stringify(res.result))
      this.companyInfo = res.result;
      // console.log(res.result);

    }).catch(error => {
      // 请求失败，
      console.log(error);
    });
  },

  methods: {
    //设置隐藏
    handleScroll() {
      this.screenHeight = document.documentElement.scrollTop || document.body.scrollTop;
      if (this.screenHeight >= 2) {
        if (this.is_header_top === false) {
          return
        }
        this.is_header_top = false
      } else {
        if (this.is_header_top === true) {
          return
        }
        this.is_header_top = true
      }
    },
    //刷新页面
    reMain() {
      window.location.reload();
    },
    navClick(index, name) {

      console.log(index, name)
      this.navIndex = index;
      sessionStorage.setItem('navIndex', index)
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },

    //语言设置
    changeLangEvent(ev) {
      if (ev === 'en-US') {
        this.langEnClass.color = '#fff'
        this.langZhClass.color = '#b6b6b6'
      } else {
        this.langEnClass.color = '#b6b6b6'
        this.langZhClass.color = '#fff'
      }
      console.log(ev)
      this.$i18n.locale = ev


      // this.$router.push({
      //   path: '/',
      // })
      this.navClick(0,'header.home')
      this.$router.replace('/software')
      this.$router.replace('/home')
    },

  }
};
</script>
<style scoped>



/* 顶部 */
#header {
  background: #fff;
  transition: all ease 0.6s;

}

#header .header-top {
  height: 45px;
  color: #fff;
  font-size: 13px;
  line-height: 45px;
  /*background: rgba(208, 208, 208, 0.95);*/
  background: linear-gradient(45deg, #0E90D5, #3032A2) !important;
}

/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
  /*margin-left: 50px;*/
}

/* 导航栏 */
#header .header-nav {
  height: 110px;
}

/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 100px;
  height: 100%;
  float: left;
  position: relative;

}

/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 230px;
  height: 90px;
  position: absolute;
  float: left;
  top: 0;
  left: -350px;
  right: 0;
  bottom: 0;
  margin: auto;
}

/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}

#header .header-nav .header-nav-wrapper {
  line-height: 110px;
  /*float: right;*/
  margin: 0;
  /*width: 1200px;*/
  max-width: 1400px;
  min-width: 400px;

}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;

  /*padding: 45px 0;*/
  display: block;
  color: #2f2b2b;
  font-weight: 600;

}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #000;
  /*font-size: 15px;*/
  font-weight: 600;
  padding: 15px 0;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #0c59db;
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #0c59db;
  text-decoration: none;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #0c59db;
  text-decoration: none;
  border-bottom: 2px solid #0c59db;
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}

/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}

#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}

@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }

  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 40px;
    position: relative;
  }

  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 110px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    /*font-size: 16px;*/
    line-height: 50px;
    background: #474747;
    position: relative;
  }

  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }

  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    padding: 15px 0;
    position: relative;
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}



</style>



// WEBPACK FOOTER //
// src/components/Header.vue